<template>
  <div class="container mb-0 pt-0 mt-60">
    <div class="vl-parent">
      <loading
        v-model:active="isLoading"
        :can-cancel="true"
        :is-full-page="fullPage"
      />
    </div>

    <div class="section-content">
      <form class="forms-sample" @submit.prevent="updateSlider" style="width: 100%">
        <!-- Header -->
        <div class="form-group row">
          <label class="col-sm-3 col-form-label">Slider Header</label>
          <div class="col-sm-9">
            <input
              class="form-control"
              v-model="sliderHeader"
              type="text"
              placeholder="Slider Header"
            />
          </div>
        </div>

        <!-- Title -->
        <div class="form-group row">
          <label class="col-sm-3 col-form-label">Slider Title</label>
          <div class="col-sm-9">
            <input
              class="form-control"
              v-model="sliderTitle"
              type="text"
              placeholder="Slider Title"
            />
          </div>
        </div>

        <!-- Slogan -->
        <div class="form-group row">
          <label class="col-sm-3 col-form-label">Slider Slogan</label>
          <div class="col-sm-9">
            <input
              class="form-control"
              v-model="sliderSlogan"
              type="text"
              placeholder="Slider Slogan"
            />
          </div>
        </div>

        <!-- Image -->
        <div class="form-group">
          <div class="row align-items-start">
            <div class="col-6">
              <label class="form-label">Slider Image</label>

              <input
                ref="fileInput"
                type="file"
                class="d-none"
                accept="image/*"
                @change="onFileChange"
              />

              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  :value="fileName"
                  placeholder="Upload Image"
                  disabled
                />
                <button class="btn btn-info" type="button" @click="$refs.fileInput.click()">
                  Upload
                </button>
              </div>
            </div>

            <div class="col-6">
              <div v-if="imagePreview" class="border p-2 rounded">
                <img
                  :src="imagePreview"
                  style="width: 160px; height: 120px; object-fit: cover; border-radius: 6px"
                  alt="Slider Image"
                />
              </div>
              <div v-else class="text-muted">No image</div>
            </div>
          </div>
        </div>

        <button class="btn btn-success" type="submit">Update</button>
      </form>
    </div>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/css/index.css";
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";

export default {
  props: {
    sliderId: { type: Number, required: true },
  },

  components: { Loading },

  data() {
    return {
      sliderHeader: "",
      sliderTitle: "",
      sliderSlogan: "",

      // ✅ consistent name
      fileToUpload: null,
      fileName: "",
      imagePreview: "",

      isLoading: false,
      fullPage: true,
    };
  },

  computed: {
    // ✅ base url always ends with /
    url() {
      let base = this.$store.state.url || "";
      return base.endsWith("/") ? base : base + "/";
    },
  },

  mounted() {
    this.fetchSlider();
  },

  methods: {
    // ✅ LOAD DATA
    async fetchSlider() {
      try {
        this.isLoading = true;

        const res = await axios.get(`${this.url}slidershow/${this.sliderId}`);

        // ✅ handle both: res.data or res.data.data
        const s = res.data?.data ?? res.data ?? {};

        // ✅ SAFE MAPPING
        this.sliderHeader = s.sliderHeader ?? s.slider_header ?? s.header ?? "";
        this.sliderTitle = s.sliderTitle ?? s.slider_title ?? s.title ?? "";
        this.sliderSlogan = s.sliderSlogan ?? s.slider_slogan ?? s.slogan ?? "";

        const filename = s.filename ?? s.img ?? s.image ?? "";
        if (filename) {
          this.fileName = filename;
          this.imagePreview = `${this.url}mainsliders/${filename}`;
        } else {
          this.fileName = "";
          this.imagePreview = "";
        }
      } catch (e) {
        console.log("fetch error:", e?.response?.status, e?.response?.data || e);
        toast.error("Failed to load slider");
      } finally {
        this.isLoading = false;
      }
    },

    // ✅ select new image
    onFileChange(e) {
      const file = e.target.files?.[0];
      if (!file) return;

      this.fileToUpload = file;
      this.fileName = file.name;
      this.imagePreview = URL.createObjectURL(file);
    },

    // ✅ UPDATE
    async updateSlider() {
      try {
        this.isLoading = true;

        const formData = new FormData();
        formData.append("sliderHeader", this.sliderHeader);
        formData.append("sliderTitle", this.sliderTitle);
        formData.append("sliderSlogan", this.sliderSlogan);

        if (this.fileToUpload) {
          formData.append("file", this.fileToUpload);
        }

        await axios.post(`${this.url}slidersupdate/${this.sliderId}`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        toast.success("Slider updated successfully", {
          autoClose: 1200,
          transition: "zoom",
          position: "top-center",
        });

        // ✅ reset selected file after upload (optional)
        this.fileToUpload = null;

        // ✅ reload
        this.fetchSlider();
      } catch (e) {
        console.log("update error:", e?.response?.status, e?.response?.data || e);
        toast.error("Failed to update slider");
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
